import MainMenu from '@/components/foundation/main-menu/MainMenu'
import Evento from '@/view/event/Event'

export const EventRoute = {
  path: '/event',
  name: 'Event',
  components: {
    default: Evento,
    mainMenu: MainMenu
  },
  meta: {
    auth: true,
    mainArea: 'event',
    area: 'event',
    breadcrumb: [
      {
        name: 'Listagem de Eventos'
      }
    ]
  }
}



// WEBPACK FOOTER //
// ./src/router/event/EventRoute.js